var openButton = document.getElementById('openLightbox');
if (openButton) {
  openButton.addEventListener('click', function () {
    lContainer.style.opacity = 1;
    lContainer.style.pointerEvents = 'all';
  });

  var lContainer = document.createElement('div');
  lContainer.setAttribute('id', 'fbLightContainer');

  var movieEmbed =
    '<div class="videoContainer"><span id="redirectBackBtn"></span><iframe id="youtubeEmbed" width="560" height="315" src="https://www.youtube.com/embed/smEN3nC4q_Q" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';

  lContainer.innerHTML += movieEmbed;
  document.body.append(lContainer);

  var closeButton = document.getElementById('redirectBackBtn');
  var iframeYT = document.getElementById('youtubeEmbed');

  closeButton.addEventListener('click', function () {
    lContainer.style.opacity = 0;
    lContainer.style.pointerEvents = 'none';
    iframeYT.src = '';
  });
  lContainer.addEventListener('click', function () {
    lContainer.style.opacity = 0;
    lContainer.style.pointerEvents = 'none';
    iframeYT.src = 'https://www.youtube.com/embed/smEN3nC4q_Q';
  });
}
